import { jsxs as l, jsx as a, Fragment as y } from "react/jsx-runtime";
import { R as w, b as O, P as R, O as x, C as D, T as I, a as c, D as M } from "./index-itexpIkB.js";
import { R as k } from "./index-DcHdoXdn.js";
import { c as i } from "./clsx-OuTLNxxd.js";
import { B } from "./button.types-khNMDxMV.js";
import { I as L } from "./icon-BnqXyiyH.js";
import "./components/elements/icon/iconsList.js";
import { Divider as j } from "./components/elements/divider/divider.js";
import { StepperDots as P } from "./components/elements/stepperDots/stepperDots.js";
const z = "_modal_j9iq0_29", o = {
  "modal-overlay": "_modal-overlay_j9iq0_29",
  "dialog-overlay-show": "_dialog-overlay-show_j9iq0_1",
  modal: z,
  "dialog-content-slide-up": "_dialog-content-slide-up_j9iq0_1",
  "dialog-content-show": "_dialog-content-show_j9iq0_1",
  "is-small": "_is-small_j9iq0_67",
  "is-medium": "_is-medium_j9iq0_70",
  "is-large": "_is-large_j9iq0_73",
  "no-confirm-action": "_no-confirm-action_j9iq0_80",
  "modal-content": "_modal-content_j9iq0_80",
  "modal-bottom": "_modal-bottom_j9iq0_83",
  "modal-title": "_modal-title_j9iq0_87",
  "is-closable": "_is-closable_j9iq0_104",
  "outer-modal-content": "_outer-modal-content_j9iq0_109",
  "modal-actions": "_modal-actions_j9iq0_131",
  "no-dividers": "_no-dividers_j9iq0_148",
  "confirm-cta": "_confirm-cta_j9iq0_151",
  "no-alternative-action": "_no-alternative-action_j9iq0_154",
  "alternative-cta": "_alternative-cta_j9iq0_157",
  "alternative-cta-multi": "_alternative-cta-multi_j9iq0_160",
  "modal-close": "_modal-close_j9iq0_169"
};
function W({
  size: q = "medium",
  title: u,
  description: d,
  onClose: m,
  children: f,
  dialogTriggerNode: v,
  alternativeAction: t,
  confirmActionText: n,
  onConfirmAction: g,
  onAlternativeAction: p,
  isOpen: C,
  onChange: _,
  areDividersVisible: s = !0,
  isClosable: h = !0,
  multiSteps: e,
  confirmationButton: N = {
    isLoading: !1,
    disabled: !1
  }
}) {
  const b = i(o.modal, o[E[q]], !n && o["no-confirm-action"]);
  return /* @__PURE__ */ l(w, { open: C, onOpenChange: (r) => {
    _ && _(r), r === !1 && m && m(r);
  }, children: [
    /* @__PURE__ */ a(O, { asChild: !0, children: v }),
    /* @__PURE__ */ l(R, { children: [
      /* @__PURE__ */ a(x, { className: o["modal-overlay"] }),
      /* @__PURE__ */ l(D, { className: b, children: [
        /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ l(I, { className: i(o["modal-title"], h && o["is-closable"]), children: [
            u,
            h && /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a("button", { className: o["modal-close"], "aria-label": "Close", children: /* @__PURE__ */ a(L, { name: "remove", size: "large" }) }) })
          ] }),
          d && /* @__PURE__ */ a(k, { asChild: !0, children: /* @__PURE__ */ a(M, { children: d }) })
        ] }),
        s && /* @__PURE__ */ a(j, { space: "no" }),
        /* @__PURE__ */ a("div", { className: o["outer-modal-content"], children: /* @__PURE__ */ a("div", { className: o["modal-content"], children: f }) }),
        n && /* @__PURE__ */ l(y, { children: [
          s && /* @__PURE__ */ a(j, { space: "no", className: o["modal-bottom"] }),
          /* @__PURE__ */ l("div", { className: i(o["modal-actions"], !s && o["no-dividers"]), children: [
            t && /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a(
              "button",
              {
                className: i(
                  o["alternative-cta"],
                  (e == null ? void 0 : e.currentStep) === 0 && o["alternative-cta-multi"]
                ),
                onClick: p,
                children: t
              }
            ) }),
            e && /* @__PURE__ */ a(P, { currentStep: e.currentStep, stepsCount: e.stepNumber }),
            /* @__PURE__ */ a(c, { asChild: !0, children: /* @__PURE__ */ a(
              B,
              {
                onClick: g,
                className: i(
                  o["confirm-cta"],
                  !e && !t && o["no-alternative-action"]
                ),
                text: n,
                ...N
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}
const E = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
export {
  W as M,
  E as a
};
